import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import {environment} from '../../environments/environment';

@Injectable({
    providedIn: 'root'
  })
  export class ReapplyAdjustmentService {
    postId;
    errorMessage;
    adjustmentresponse;
    // REAPPLY_SVC_URL
    private REAPPLY_SVC_URL = environment.REAPPLY_SVC_URL;

    private reapplyItemsSubject: Subject<any[]>;
    reapplyItemsObservable: Observable<any[]>;

    constructor(private httpClient: HttpClient) {
        this.reapplyItemsSubject = new Subject<any[]>();
        this.reapplyItemsObservable = this.reapplyItemsSubject.asObservable();
    }

    postAdjustmentData(auditId: number, classroomId: number, startingPercent: number, gracePeriod: number, courseId: number, courseCode: string, officialCourseStartDate: string,
      studentAccountId: number, studentSchoolId: number, studentIdentityId: number, timestamp: number) {
      this.sendPostRequest(auditId, classroomId, startingPercent, gracePeriod, courseId, courseCode, officialCourseStartDate, studentAccountId, studentSchoolId, studentIdentityId, timestamp).subscribe((
        (data: any[]) => {
          this.adjustmentresponse = data;
          this.reapplyItemsSubject.next(this.adjustmentresponse);
        }
    ));
    return this.adjustmentresponse;
    }

    sendPostRequest(auditId: number, classroomId: number, startingPercent: number, gracePeriod: number, courseId: number, courseCode: string, officialCourseStartDate: string,
      studentAccountId: number, studentSchoolId: number, studentIdentityId: number, timestamp: number) {
      return       this.httpClient.post<any>(this.REAPPLY_SVC_URL, { auditId: auditId, classroomId: classroomId, startingPercent: startingPercent, gracePeriod: gracePeriod, courseId: courseId,
        courseCode: courseCode, officialCourseStartDate: officialCourseStartDate, studentAccountId: studentAccountId, studentSchoolId: studentSchoolId,
        studentIdentityId: studentIdentityId, timestamp: timestamp });
    }
  }

